// extracted by mini-css-extract-plugin
export default {"fullWidth":"filters_fullWidth__C+OZS"};